import React from 'react';
import { GiHamburgerMenu } from 'react-icons/gi';
import images from '../../constants/images';
import './Navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = React.useState(false);
  return (
    <nav className="app__navbar app__bg">
      <div className="app__navbar-logo">
        {/* <img src={images.csa_logo} alt="app__logo" /> */}
      </div>
      <ul className="app__navbar-links">
        <li className="p__opensans"><a href="#home">Home</a></li>
        <li className="p__opensans"><a href="#about">About</a></li>
        <li className="p__opensans"><a href="#mountains">Mountains</a></li>
        <li className="p__opensans"><a href="#members">Members</a></li>
      </ul>
      <div className="app__navbar-smallscreen">
        <GiHamburgerMenu color="#fff" fontSize={27} onClick={() => setToggleMenu(true)} />
        {toggleMenu && (
          <div className="app__navbar-smallscreen_overlay flex__center slide-bottom">
            <img src={images.ski_ex} alt="alt_ski"  className="overlay__close" onClick={() => setToggleMenu(false)} />
            <ul className="app__navbar-smallscreen_links">
              <li><a href="#home" onClick={() => setToggleMenu(false)}>Home</a></li>
              <li><a href="#about" onClick={() => setToggleMenu(false)}>About</a></li>
              <li><a href="#mountains" onClick={() => setToggleMenu(false)}>Mountains</a></li>
              <li><a href="#members" onClick={() => setToggleMenu(false)}>Members</a></li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;